export default {
  namespaced: true,

  state: () => ({
    bannerList: {
      data: [],
      links: {},
      meta: {},
    },
    banner: {},
    labelForm: {
      banner: {
        title: 'Banner',
        description: [],
      },
      name: {
        title: 'Nama',
        description: [],
      },
      type: {
        title: 'Tipe',
        description: [],
      },
      description: {
        title: 'Deskripsi',
        description: [],
      },
      active: {
        title: 'Status',
        description: [],
      },
      location: {
        title: 'Lokasi',
        description: ['Pilih dimana banner ini akan ditampilkan.'],
      },
      link: {
        title: 'Link',
        description: [],
      },
    },
    locationList: [
      {
        title: 'Homepage',
        value: 'homepage',
      },
      {
        title: 'Halaman Review',
        value: 'review-page',
      },
    ],
  }),

  mutations: {
    SET_BANNER_LIST(state, payload) {
      state.bannerList = payload
    },
    SET_BANNER(state, payload) {
      state.banner = payload
    },
  },

  actions: {
    // get list banner
    async getBannerList({ commit }, {
      page = null, keyword = undefined, active = undefined, order = undefined,
    } = {}) {
      try {
        const url = '/v1/admin/banners'

        const response = await this._vm.$http.get(url, {
          params: {
            page,
            'filter[keyword]': keyword,
            'filter[active]': active,
            'filter[has_order]': order,
            sort: 'order',
          },
        })

        commit('SET_BANNER_LIST', response.data)

        return response.data
      } catch (error) {
        return error
      }
    },

    async getBannerListV2({ commit }, {
      page = null, keyword = undefined, active = undefined, order = undefined,
    } = {}) {
      try {
        const url = '/v2/admin/banners'

        const response = await this._vm.$http.get(url, {
          params: {
            page,
            'filter[keyword]': keyword,
            'filter[active]': active,
            'filter[has_order]': order,
            sort: 'order',
          },
        })

        commit('SET_BANNER_LIST', response.data)

        return response.data
      } catch (error) {
        return error
      }
    },

    // get banner
    async getBanner({ commit }, { id }) {
      try {
        const url = `/v1/admin/banners/${id}`

        const response = await this._vm.$http.get(url)

        commit('SET_BANNER', response.data)

        return response.data
      } catch (error) {
        commit('response/SET_ERROR', {
          message: 'Gagal Memuat Data!',
        }, { root: true })
        return error
      }
    },

    // create
    async createBanner({ commit }, data) {
      try {
        const url = '/v1/admin/banners'

        const isActive = data.active ? 1 : 0

        const formData = new FormData()
        formData.append('image', data.imageFile)
        formData.append('name', data.name)
        formData.append('type', data.type)
        formData.append('description', data.description)
        formData.append('link', data.link)
        formData.append('location', data.location)
        formData.append('active', isActive)

        const response = await this._vm.$http.post(url, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        })

        commit('response/SET_SUCCESS', {
          message: 'Berhasil Menambahkan Banner!',
        }, { root: true })

        return response.data
      } catch (error) {
        commit('response/SET_ERROR', {
          message: 'Gagal Menambahkan Banner!',
        }, { root: true })

        return error
      }
    },

    // edit
    async updateBanner({ commit }, { data, bannerId }) {
      try {
        const url = `/v1/admin/banners/${bannerId}`

        const isActive = data.active ? 1 : 0

        const formData = new FormData()
        if (data.imageFile) formData.append('image', data.imageFile)
        formData.append('name', data.name)
        formData.append('type', data.type)
        formData.append('description', data.description)
        formData.append('link', data.link)
        formData.append('active', isActive)
        formData.append('location', data.location)
        formData.append('_method', 'PUT')

        const response = await this._vm.$http.post(url, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        })

        commit('response/SET_SUCCESS', {
          message: 'Berhasil Mengubah Banner!',
        }, { root: true })

        return response.data
      } catch (error) {
        commit('response/SET_ERROR', {
          message: 'Gagal Mengubah Banner!',
        }, { root: true })

        throw new Error(error.message)
      }
    },

    // activated toogle
    async updateActivated({ commit }, { bannerId = null, data = null, value = null }) {
      try {
        const url = `/v1/admin/banners/${bannerId}`

        const isActive = value ? 1 : 0

        const formData = new FormData()
        formData.append('active', isActive)
        formData.append('name', data.name)
        formData.append('type', data.type)
        formData.append('_method', 'PUT')

        const response = await this._vm.$http.post(url, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        })

        commit('response/SET_SUCCESS', {
          message: `Berhasil ${isActive ? 'Mengaktifkan' : 'Menonaktifkan'} Banner!`,
        }, { root: true })

        return response.data
      } catch (error) {
        commit('response/SET_ERROR', {
          message: 'Gagal Mengubah!',
        }, { root: true })

        throw new Error(error.message)
      }
    },

    // delete
    async deleteBanner({ commit, dispatch }, { bannerId }) {
      try {
        const url = `/v1/admin/banners/${bannerId}`

        const response = await this._vm.$http.delete(url)

        dispatch('getBannerList')

        commit('response/SET_SUCCESS', {
          message: 'Berhasil Menghapus Banner!',
        }, { root: true })

        return response.data
      } catch (error) {
        commit('response/SET_ERROR', {
          message: 'Gagal Menghapus Banner!',
        }, { root: true })

        return error
      }
    },

    // order
    async orderBanner({ commit }, { order = [] }) {
      try {
        const url = '/v1/admin/banners/order'

        const response = await this._vm.$http.post(url, {
          id: order,
        })

        commit('response/SET_SUCCESS', {
          message: 'Berhasil Mengurutkan Banner!',
        }, { root: true })

        return response.data
      } catch (error) {
        commit('response/SET_ERROR', {
          message: 'Gagal Mengurutkan Banner!',
        }, { root: true })

        return error
      }
    },

    async orderBannerV2({ commit }, { order = [] }) {
      try {
        const url = '/v2/admin/banners/order'

        const response = await this._vm.$http.post(url, {
          id: order,
        })

        commit('response/SET_SUCCESS', {
          message: 'Berhasil Mengurutkan Banner!',
        }, { root: true })

        return response.data
      } catch (error) {
        commit('response/SET_ERROR', {
          message: 'Gagal Mengurutkan Banner!',
        }, { root: true })

        return error
      }
    },
  },
}
